import isNumber from 'lodash/isNumber';
import React, { useState, ChangeEvent } from 'react';
import { Input } from 'styleguide';

import { useMultiNodes } from 'craft/hooks';
import { PropToEdit } from 'craft/types';

interface Props {
  nodeIds: string[];
  propToEdit: PropToEdit;
}

const NumberPropField = ({ nodeIds, propToEdit }: Props) => {
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const {
    actions: { setProps },
  } = useMultiNodes(nodeIds);

  const { schema, value: currentValue } = propToEdit;
  const defaultValue = currentValue || schema.fieldType.defaultValue;

  const onChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    if (!value && schema.fieldType.isRequired) {
      return setErrorMessage('Please enter a value');
    }
    const parsedNumber = parseInt(value, 10);
    if (!isNumber(parsedNumber) || Number.isNaN(parsedNumber)) {
      return setErrorMessage('Please enter a valid number');
    }
    setErrorMessage(null);
    return setProps({ [schema.id]: parsedNumber });
  };

  return <Input defaultValue={defaultValue} onChange={onChange} errorMessage={errorMessage} />;
};

export default NumberPropField;
